/**
 * Buy More, Save More - Quantity Bundle Widget
 * digibazar.pk
 * (Cart / Buy Now buttons combined-checkout.js handle karta hai)
 */

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-qbm]');
  if (!wrapper) return;

  function placeAboveBuyButtons() {
    const buyButtons = document.querySelector(
      '.product-form__buttons, [data-testid="buy-buttons"], .product-form, product-form, form[action*="/cart/add"]'
    );
    if (!buyButtons) return;
    if (wrapper.parentNode === buyButtons.parentNode) return;

    let targetParent = buyButtons.parentNode;
    if (targetParent && targetParent.classList.contains('product-form')) {
      targetParent = targetParent.parentNode;
    }
    if (targetParent && targetParent.parentNode) {
      targetParent.parentNode.insertBefore(wrapper, targetParent);
    } else if (buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(wrapper, buyButtons);
    }
  }

  placeAboveBuyButtons();
  setTimeout(placeAboveBuyButtons, 250);

  let basePrice = parseInt(wrapper.dataset.basePrice || '0', 10);
  let comparePrice = parseInt(wrapper.dataset.comparePrice || '0', 10);
  const productId = wrapper.dataset.productId;
  const productHandle = wrapper.dataset.productHandle;
  const mainVariantId = wrapper.dataset.variantId;

  const options = wrapper.querySelectorAll('[data-qbm-option]');

  let selectedQty = 1;
  let selectedDiscount = 0;
  let selectedCode = '';
  let selectedOption = null;
  let suppressMainListener = false;

  let allVariants = [];
  let optionsMeta = [];
  let variantsLoaded = false;

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    const amount = cents / 100;
    if (amount % 1 === 0) return 'Rs. ' + amount.toLocaleString('en-US');
    return 'Rs. ' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function toCents(value, fallback) {
    if (value === undefined || value === null) return fallback;
    return typeof value === 'string' ? Math.round(parseFloat(value) * 100) : value;
  }

  function findVariantForRow(rowEl) {
    if (!variantsLoaded || allVariants.length === 0) return null;
    const selects = rowEl.querySelectorAll('[data-qbm-row-select]');
    if (selects.length === 0) return null;

    const chosen = {};
    selects.forEach(function (sel) {
      chosen[sel.dataset.optionName] = sel.value;
    });

    for (let i = 0; i < allVariants.length; i++) {
      const v = allVariants[i];
      if (!v.available) continue;
      let isMatch = true;
      for (let j = 0; j < optionsMeta.length; j++) {
        const meta = optionsMeta[j];
        const key = 'option' + meta.position;
        if (chosen[meta.name] !== undefined && v[key] !== chosen[meta.name]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) return v;
    }
    return null;
  }

  function recomputeOptionPrice(optionEl) {
    const qty = parseInt(optionEl.dataset.qty, 10);
    const discount = parseInt(optionEl.dataset.discount || '0', 10);
    const rows = optionEl.querySelectorAll('.qbm-variant-row');

    let subtotal = 0;
    let compareSubtotal = 0;
    const rowVariantIds = [];

    rows.forEach(function (row) {
      const variant = findVariantForRow(row);
      const price = variant ? toCents(variant.price, basePrice) : basePrice;
      const compareAt = variant
        ? (variant.compare_at_price ? toCents(variant.compare_at_price, price) : price)
        : (comparePrice > basePrice ? comparePrice : price);

      subtotal += price;
      compareSubtotal += compareAt > price ? compareAt : price;
      rowVariantIds.push(variant ? variant.id : mainVariantId);
    });

    optionEl.__rowVariantIds = rowVariantIds;
    optionEl.__rowSubtotal = subtotal;

    const discountedTotal = Math.round(subtotal * (1 - discount / 100));

    const priceEl = optionEl.querySelector('[data-qbm-price]');
    const compareEl = optionEl.querySelector('[data-qbm-compare]');

    if (priceEl) priceEl.textContent = formatMoney(discountedTotal);
    if (compareEl) {
      if (compareSubtotal > subtotal || discount > 0) {
        compareEl.textContent = formatMoney(compareSubtotal > subtotal ? compareSubtotal : subtotal);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    return discountedTotal;
  }

  function updateOptionPrices() {
    let selectedTotal = 0;
    options.forEach(function (option) {
      const total = recomputeOptionPrice(option);
      if (option === selectedOption) selectedTotal = total;
    });

    const rawTotal = (selectedOption && selectedOption.__rowSubtotal) || 0;
    const qbmItems = ((selectedOption && selectedOption.__rowVariantIds) || [])
      .filter(function (id) { return id; })
      .map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

    // combined-checkout.js isi object aur event ko use karta hai
    window.DigiQBM = { total: selectedTotal, rawTotal: rawTotal, items: qbmItems, code: selectedCode, qty: selectedQty };
    document.dispatchEvent(new CustomEvent('qbm:update', { detail: window.DigiQBM }));
  }

  // ═══════════════════════════════════════════════════════════════════
  // UPDATE FBT DYNAMIC MESSAGE
  // ═══════════════════════════════════════════════════════════════════
  function updateFBTMessage() {
    const fbtWrapper = document.querySelector('[data-fbt-tiered]');
    if (!fbtWrapper) return;

    const messageEl = fbtWrapper.querySelector('[data-fbt-dynamic-message]');
    const messageTextEl = fbtWrapper.querySelector('[data-fbt-dynamic-message-text]');
    const savingsEl = fbtWrapper.querySelector('[data-fbt-savings]');
    const savingsAmountEl = fbtWrapper.querySelector('[data-fbt-savings-amount]');
    const savingsPercentEl = fbtWrapper.querySelector('[data-fbt-savings-percent]');

    if (!messageEl || !messageTextEl) return;

    let qty = selectedQty;
    let message = '';

    if (qty === 1) {
      message = '🎉 Buy 1 more to unlock 5% OFF';
    } else if (qty === 2) {
      message = '🎉 5% OFF Unlocked! Buy 1 more for 10% OFF';
    } else if (qty === 3) {
      message = '🎉 10% OFF Unlocked! Buy 2 more for 15% OFF';
    } else if (qty === 4) {
      message = '🎉 10% OFF Unlocked! Buy 1 more for 15% OFF';
    } else if (qty >= 5) {
      message = '🎉 Maximum 15% OFF Unlocked!';
    }

    if (message) {
      messageTextEl.textContent = message;
      messageEl.hidden = false;
    } else {
      messageEl.hidden = true;
    }

    // Update savings badge in FBT footer
    if (savingsEl && savingsAmountEl && savingsPercentEl) {
      const subtotal = basePrice * qty;
      const discountAmt = Math.round(subtotal * (selectedDiscount / 100));
      if (selectedDiscount > 0 && discountAmt > 0) {
        savingsAmountEl.textContent = formatMoney(discountAmt);
        savingsPercentEl.textContent = '(' + selectedDiscount + '% OFF)';
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  function selectOption(option) {
    options.forEach(function (opt) {
      opt.classList.remove('is-selected');
      const radio = opt.querySelector('.qbm-radio');
      if (radio) radio.checked = false;
    });

    option.classList.add('is-selected');
    const radio = option.querySelector('.qbm-radio');
    if (radio) radio.checked = true;

    selectedOption = option;
    selectedQty = parseInt(option.dataset.qty, 10);
    selectedDiscount = parseInt(option.dataset.discount || '0', 10);
    selectedCode = option.dataset.code || '';

    updateOptionPrices();

    const firstRow = option.querySelector('.qbm-variant-row[data-row-index="1"]');
    if (firstRow) {
      const variant = findVariantForRow(firstRow);
      if (variant) syncMainProductWithVariant(variant);
    }
  }

  options.forEach(function (option) {
    option.addEventListener('click', function (e) {
      if (e.target.closest('.qbm-select')) return;
      selectOption(option);
    });

    const radio = option.querySelector('.qbm-radio');
    if (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) selectOption(option);
      });
    }

    if (option.classList.contains('is-selected')) {
      selectedOption = option;
    }
  });

  // ═══════════════════════════════════════════════════════════════════
  // SYNC MAIN PRODUCT PAGE WITH VARIANT
  // ═══════════════════════════════════════════════════════════════════
  function syncMainProductWithVariant(variant) {
    if (!variant) return;
    suppressMainListener = true;

    const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    let clickedAny = false;

    const allRadios = document.querySelectorAll('input[type="radio"]');
    allRadios.forEach(function (radio) {
      if (radio.closest('[data-qbm]')) return;
      if (!radio.name) return;
      if (radio.name === 'qbm-bundle') return;
      if (variantOptions.indexOf(radio.value) === -1) return;
      const container = radio.closest('variant-selects, variant-radios, fieldset, form[action*="/cart/add"]');
      if (!container) return;
      radio.click();
      clickedAny = true;
    });

    if (!clickedAny) {
      const allSelects = document.querySelectorAll(
        'variant-selects select, variant-radios select, form[action*="/cart/add"] select'
      );
      allSelects.forEach(function (sel) {
        if (sel.closest('[data-qbm]')) return;
        if (sel.name === 'id') return;
        for (let i = 0; i < variantOptions.length; i++) {
          const optVal = variantOptions[i];
          const matchingOption = Array.from(sel.options).find(function (o) { return o.value === optVal; });
          if (matchingOption) {
            sel.value = optVal;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            clickedAny = true;
            break;
          }
        }
      });
    }

    suppressMainListener = false;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    const pageIdInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    );
    if (pageIdInput) pageIdInput.value = variant.id;

    if (variant.featured_image) {
      const imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || null);
      if (imageUrl) {
        const mainSelectors = ['media-gallery img', '.product__media img', '.product-gallery img', '.product-media img', '.product-single__photo img', '[data-product-media] img', '[data-media-gallery] img'];
        document.querySelectorAll(mainSelectors.join(', ')).forEach(function (img) {
          if (img.closest('[data-qbm]')) return;
          img.src = imageUrl;
          if (img.srcset) img.srcset = '';
        });
      }
    }

    if (variant.price) {
      const priceCents = toCents(variant.price, 0);
      const compareCents = variant.compare_at_price ? toCents(variant.compare_at_price, priceCents) : 0;
      const priceSelectors = ['.price__current', '.price-item--sale', '.product__price', '.product-price', '[data-product-price]', '.price'];
      const priceEl = document.querySelector(priceSelectors.join(', '));
      if (priceEl && priceCents) priceEl.textContent = formatMoney(priceCents);
      if (compareCents > priceCents) {
        const compareEl = document.querySelector('.price__compare, .price-item--regular, .compare-at-price, s.price-item');
        if (compareEl) compareEl.textContent = formatMoney(compareCents);
      }
    }

    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));

    const sectionId = getSectionId();
    const fetchUrl = window.location.pathname + '?variant=' + variant.id + (sectionId ? '&section_id=' + sectionId : '');

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const variantUpdateEvent = new CustomEvent('variant:update', {
          bubbles: true,
          detail: { data: { html: doc, variant: variant, productId: productId } }
        });
        const sectionWrapper = wrapper.closest('.shopify-section');
        if (sectionWrapper) sectionWrapper.dispatchEvent(variantUpdateEvent);
        document.dispatchEvent(variantUpdateEvent);
      })
      .catch(function (err) { console.warn('QBM variant sync fetch error:', err); });
  }

  function getSectionId() {
    const sectionWrapper = wrapper.closest('[id^="shopify-section-"]');
    if (sectionWrapper) return sectionWrapper.id.replace('shopify-section-', '');
    return '';
  }

  wrapper.addEventListener('change', function (e) {
    const select = e.target.closest('[data-qbm-row-select]');
    if (!select) return;
    const row = select.closest('.qbm-variant-row');
    const option = select.closest('[data-qbm-option]');
    if (!row || !option) return;
    updateOptionPrices();
    if (option === selectedOption) {
      const variant = findVariantForRow(row);
      if (variant) syncMainProductWithVariant(variant);
    }
  });

  function getOptionValueSets() {
    const sets = {};
    optionsMeta.forEach(function (meta) {
      const key = 'option' + meta.position;
      const valueSet = new Set();
      allVariants.forEach(function (v) { if (v[key]) valueSet.add(v[key]); });
      sets[meta.name] = valueSet;
    });
    return sets;
  }

  document.addEventListener('change', function (e) {
    if (suppressMainListener) return;
    if (!variantsLoaded) return;
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.closest('[data-qbm]')) return;

    let value = null;
    if (target.matches('input[type="radio"]')) {
      if (!target.checked) return;
      value = target.value;
    } else if (target.matches('select')) {
      if (target.name === 'id') return;
      value = target.value;
    } else {
      return;
    }
    if (!value) return;

    const valueSets = getOptionValueSets();
    let matchedName = null;
    Object.keys(valueSets).forEach(function (name) {
      if (valueSets[name].has(value)) matchedName = name;
    });
    if (!matchedName) return;

    wrapper.querySelectorAll('[data-qbm-row-select]').forEach(function (sel) {
      if (sel.dataset.optionName !== matchedName) return;
      const hasOption = Array.from(sel.options).some(function (o) { return o.value === value; });
      if (hasOption) sel.value = value;
    });

    updateOptionPrices();
  });

  fetch('/products/' + encodeURIComponent(productHandle) + '.js')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      allVariants = data.variants || [];
      optionsMeta = (data.options || []).map(function (name, idx) {
        return { name: typeof name === 'string' ? name : name.name, position: idx + 1 };
      });
      variantsLoaded = true;
      updateOptionPrices();
    })
    .catch(function (err) { console.error('QBM variant fetch error:', err); });

  updateOptionPrices();
});







// 1
// /**
//  * Buy More, Save More - Quantity Bundle Widget
//  * digibazar.pk
//  */

// document.addEventListener('DOMContentLoaded', function () {
//   const wrapper = document.querySelector('[data-qbm]');
//   if (!wrapper) return;

//   function placeAboveBuyButtons() {
//     const buyButtons = document.querySelector(
//       '.product-form__buttons, [data-testid="buy-buttons"], .product-form, product-form, form[action*="/cart/add"]'
//     );
//     if (!buyButtons) return;
//     if (wrapper.parentNode === buyButtons.parentNode) return;

//     let targetParent = buyButtons.parentNode;
//     if (targetParent && targetParent.classList.contains('product-form')) {
//       targetParent = targetParent.parentNode;
//     }
//     if (targetParent && targetParent.parentNode) {
//       targetParent.parentNode.insertBefore(wrapper, targetParent);
//     } else if (buyButtons.parentNode) {
//       buyButtons.parentNode.insertBefore(wrapper, buyButtons);
//     }
//   }

//   placeAboveBuyButtons();
//   setTimeout(placeAboveBuyButtons, 250);

//   let basePrice = parseInt(wrapper.dataset.basePrice || '0', 10);
//   let comparePrice = parseInt(wrapper.dataset.comparePrice || '0', 10);
//   const productId = wrapper.dataset.productId;
//   const productHandle = wrapper.dataset.productHandle;
//   const mainVariantId = wrapper.dataset.variantId;

//   const options = wrapper.querySelectorAll('[data-qbm-option]');
//   const addBtn = wrapper.querySelector('[data-qbm-add-btn]');
//   const addText = wrapper.querySelector('[data-qbm-add-text]');
//   const addSpinner = addBtn ? addBtn.querySelector('.qbm-add-spinner') : null;
//   const viewCartBtn = wrapper.querySelector('[data-qbm-view-cart-btn]');
//   const buyNowBtn = wrapper.querySelector('[data-qbm-buy-now-btn]');
//   const buyNowText = wrapper.querySelector('[data-qbm-buy-now-text]');
//   const buyNowSpinner = buyNowBtn ? buyNowBtn.querySelector('.qbm-add-spinner') : null;
//   const errorEl = wrapper.querySelector('[data-qbm-error]');

//   let selectedQty = 1;
//   let selectedDiscount = 0;
//   let selectedCode = '';
//   let selectedOption = null;
//   let suppressMainListener = false;

//   let allVariants = [];
//   let optionsMeta = [];
//   let variantsLoaded = false;

//   function formatMoney(cents) {
//     if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
//     const amount = cents / 100;
//     if (amount % 1 === 0) return 'Rs. ' + amount.toLocaleString('en-US');
//     return 'Rs. ' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   }

//   function toCents(value, fallback) {
//     if (value === undefined || value === null) return fallback;
//     return typeof value === 'string' ? Math.round(parseFloat(value) * 100) : value;
//   }

//   function findVariantForRow(rowEl) {
//     if (!variantsLoaded || allVariants.length === 0) return null;
//     const selects = rowEl.querySelectorAll('[data-qbm-row-select]');
//     if (selects.length === 0) return null;

//     const chosen = {};
//     selects.forEach(function (sel) {
//       chosen[sel.dataset.optionName] = sel.value;
//     });

//     for (let i = 0; i < allVariants.length; i++) {
//       const v = allVariants[i];
//       if (!v.available) continue;
//       let isMatch = true;
//       for (let j = 0; j < optionsMeta.length; j++) {
//         const meta = optionsMeta[j];
//         const key = 'option' + meta.position;
//         if (chosen[meta.name] !== undefined && v[key] !== chosen[meta.name]) {
//           isMatch = false;
//           break;
//         }
//       }
//       if (isMatch) return v;
//     }
//     return null;
//   }

//   function recomputeOptionPrice(optionEl) {
//     const qty = parseInt(optionEl.dataset.qty, 10);
//     const discount = parseInt(optionEl.dataset.discount || '0', 10);
//     const rows = optionEl.querySelectorAll('.qbm-variant-row');

//     let subtotal = 0;
//     let compareSubtotal = 0;
//     const rowVariantIds = [];

//     rows.forEach(function (row) {
//       const variant = findVariantForRow(row);
//       const price = variant ? toCents(variant.price, basePrice) : basePrice;
//       const compareAt = variant
//         ? (variant.compare_at_price ? toCents(variant.compare_at_price, price) : price)
//         : (comparePrice > basePrice ? comparePrice : price);

//       subtotal += price;
//       compareSubtotal += compareAt > price ? compareAt : price;
//       rowVariantIds.push(variant ? variant.id : mainVariantId);
//     });

//       optionEl.__rowVariantIds = rowVariantIds;
//     optionEl.__rowSubtotal = subtotal;

//     const discountedTotal = Math.round(subtotal * (1 - discount / 100));

//     const priceEl = optionEl.querySelector('[data-qbm-price]');
//     const compareEl = optionEl.querySelector('[data-qbm-compare]');

//     if (priceEl) priceEl.textContent = formatMoney(discountedTotal);
//     if (compareEl) {
//       if (compareSubtotal > subtotal || discount > 0) {
//         compareEl.textContent = formatMoney(compareSubtotal > subtotal ? compareSubtotal : subtotal);
//         compareEl.style.display = '';
//       } else {
//         compareEl.style.display = 'none';
//       }
//     }

//     return discountedTotal;
//   }

//   function updateOptionPrices() {
//     let selectedTotal = 0;
//     options.forEach(function (option) {
//       const total = recomputeOptionPrice(option);
//       if (option === selectedOption) selectedTotal = total;
//     });

//     if (addText) addText.textContent = 'Add ' + selectedQty + ' to Cart - ' + formatMoney(selectedTotal);
//     if (buyNowText) buyNowText.textContent = 'Buy Now - ' + formatMoney(selectedTotal);

//     const rawTotal = (selectedOption && selectedOption.__rowSubtotal) || 0;
//     const qbmItems = ((selectedOption && selectedOption.__rowVariantIds) || [])
//       .filter(function (id) { return id; })
//       .map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

//     window.DigiQBM = { total: selectedTotal, rawTotal: rawTotal, items: qbmItems, code: selectedCode, qty: selectedQty };
//     document.dispatchEvent(new CustomEvent('qbm:update', { detail: window.DigiQBM }));
//   }
//   // ═══════════════════════════════════════════════════════════════════
//   // UPDATE FBT DYNAMIC MESSAGE
//   // ═══════════════════════════════════════════════════════════════════
//   function updateFBTMessage() {
//     const fbtWrapper = document.querySelector('[data-fbt-tiered]');
//     if (!fbtWrapper) return;

//     const messageEl = fbtWrapper.querySelector('[data-fbt-dynamic-message]');
//     const messageTextEl = fbtWrapper.querySelector('[data-fbt-dynamic-message-text]');
//     const savingsEl = fbtWrapper.querySelector('[data-fbt-savings]');
//     const savingsAmountEl = fbtWrapper.querySelector('[data-fbt-savings-amount]');
//     const savingsPercentEl = fbtWrapper.querySelector('[data-fbt-savings-percent]');

//     if (!messageEl || !messageTextEl) return;

//     let qty = selectedQty;
//     let message = '';

//     if (qty === 1) {
//       message = '🎉 Buy 1 more to unlock 5% OFF';
//     } else if (qty === 2) {
//       message = '🎉 5% OFF Unlocked! Buy 1 more for 10% OFF';
//     } else if (qty === 3) {
//       message = '🎉 10% OFF Unlocked! Buy 2 more for 15% OFF';
//     } else if (qty === 4) {
//       message = '🎉 10% OFF Unlocked! Buy 1 more for 15% OFF';
//     } else if (qty >= 5) {
//       message = '🎉 Maximum 15% OFF Unlocked!';
//     }

//     if (message) {
//       messageTextEl.textContent = message;
//       messageEl.hidden = false;
//     } else {
//       messageEl.hidden = true;
//     }

//     // Update savings badge in FBT footer
//     if (savingsEl && savingsAmountEl && savingsPercentEl) {
//       const subtotal = basePrice * qty;
//       const discountAmt = Math.round(subtotal * (selectedDiscount / 100));
//       if (selectedDiscount > 0 && discountAmt > 0) {
//         savingsAmountEl.textContent = formatMoney(discountAmt);
//         savingsPercentEl.textContent = '(' + selectedDiscount + '% OFF)';
//         savingsEl.hidden = false;
//       } else {
//         savingsEl.hidden = true;
//       }
//     }
//   }

//   function selectOption(option) {
//     options.forEach(function (opt) {
//       opt.classList.remove('is-selected');
//       const radio = opt.querySelector('.qbm-radio');
//       if (radio) radio.checked = false;
//     });

//     option.classList.add('is-selected');
//     const radio = option.querySelector('.qbm-radio');
//     if (radio) radio.checked = true;

//     selectedOption = option;
//     selectedQty = parseInt(option.dataset.qty, 10);
//     selectedDiscount = parseInt(option.dataset.discount || '0', 10);
//     selectedCode = option.dataset.code || '';

//     updateOptionPrices();

//     const firstRow = option.querySelector('.qbm-variant-row[data-row-index="1"]');
//     if (firstRow) {
//       const variant = findVariantForRow(firstRow);
//       if (variant) syncMainProductWithVariant(variant);
//     }
//   }

//   options.forEach(function (option) {
//     option.addEventListener('click', function (e) {
//       if (e.target.closest('.qbm-select')) return;
//       selectOption(option);
//     });

//     const radio = option.querySelector('.qbm-radio');
//     if (radio) {
//       radio.addEventListener('change', function () {
//         if (radio.checked) selectOption(option);
//       });
//     }

//     if (option.classList.contains('is-selected')) {
//       selectedOption = option;
//     }
//   });

//   function resetBuyNowButton() {
//     if (!buyNowBtn) return;
//     buyNowBtn.disabled = false;
//     if (buyNowSpinner) buyNowSpinner.hidden = true;
//     if (buyNowText) buyNowText.textContent = 'Buy Now';
//   }

//   function resetAddToCartButton() {
//     if (!addBtn) return;
//     addBtn.disabled = false;
//     if (addSpinner) addSpinner.hidden = true;
//   }

//   function resetAllButtons() {
//     resetBuyNowButton();
//     resetAddToCartButton();
//     updateOptionPrices();
//   }

//   window.addEventListener('pageshow', function (event) {
//     if (event.persisted) resetAllButtons();
//   });

//   document.addEventListener('visibilitychange', function () {
//     if (document.visibilityState === 'visible') resetAllButtons();
//   });

//   window.addEventListener('focus', function () {
//     resetAllButtons();
//   });

//   // ═══════════════════════════════════════════════════════════════════
//   // SYNC MAIN PRODUCT PAGE WITH VARIANT
//   // ═══════════════════════════════════════════════════════════════════
//   function syncMainProductWithVariant(variant) {
//     if (!variant) return;
//     suppressMainListener = true;

//     const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
//     let clickedAny = false;

//     const allRadios = document.querySelectorAll('input[type="radio"]');
//     allRadios.forEach(function (radio) {
//       if (radio.closest('[data-qbm]')) return;
//       if (!radio.name) return;
//       if (radio.name === 'qbm-bundle') return;
//       if (variantOptions.indexOf(radio.value) === -1) return;
//       const container = radio.closest('variant-selects, variant-radios, fieldset, form[action*="/cart/add"]');
//       if (!container) return;
//       radio.click();
//       clickedAny = true;
//     });

//     if (!clickedAny) {
//       const allSelects = document.querySelectorAll(
//         'variant-selects select, variant-radios select, form[action*="/cart/add"] select'
//       );
//       allSelects.forEach(function (sel) {
//         if (sel.closest('[data-qbm]')) return;
//         if (sel.name === 'id') return;
//         for (let i = 0; i < variantOptions.length; i++) {
//           const optVal = variantOptions[i];
//           const matchingOption = Array.from(sel.options).find(function (o) { return o.value === optVal; });
//           if (matchingOption) {
//             sel.value = optVal;
//             sel.dispatchEvent(new Event('change', { bubbles: true }));
//             clickedAny = true;
//             break;
//           }
//         }
//       });
//     }

//     suppressMainListener = false;

//     try {
//       const url = new URL(window.location.href);
//       url.searchParams.set('variant', variant.id);
//       window.history.replaceState({}, '', url.toString());
//     } catch (e) {}

//     const pageIdInput = document.querySelector(
//       'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
//     );
//     if (pageIdInput) pageIdInput.value = variant.id;

//     if (variant.featured_image) {
//       const imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || null);
//       if (imageUrl) {
//         const mainSelectors = ['media-gallery img', '.product__media img', '.product-gallery img', '.product-media img', '.product-single__photo img', '[data-product-media] img', '[data-media-gallery] img'];
//         document.querySelectorAll(mainSelectors.join(', ')).forEach(function (img) {
//           if (img.closest('[data-qbm]')) return;
//           img.src = imageUrl;
//           if (img.srcset) img.srcset = '';
//         });
//       }
//     }

//     if (variant.price) {
//       const priceCents = toCents(variant.price, 0);
//       const compareCents = variant.compare_at_price ? toCents(variant.compare_at_price, priceCents) : 0;
//       const priceSelectors = ['.price__current', '.price-item--sale', '.product__price', '.product-price', '[data-product-price]', '.price'];
//       const priceEl = document.querySelector(priceSelectors.join(', '));
//       if (priceEl && priceCents) priceEl.textContent = formatMoney(priceCents);
//       if (compareCents > priceCents) {
//         const compareEl = document.querySelector('.price__compare, .price-item--regular, .compare-at-price, s.price-item');
//         if (compareEl) compareEl.textContent = formatMoney(compareCents);
//       }
//     }

//     document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));

//     const sectionId = getSectionId();
//     const fetchUrl = window.location.pathname + '?variant=' + variant.id + (sectionId ? '&section_id=' + sectionId : '');

//     fetch(fetchUrl)
//       .then(function (res) { return res.text(); })
//       .then(function (html) {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const variantUpdateEvent = new CustomEvent('variant:update', {
//           bubbles: true,
//           detail: { data: { html: doc, variant: variant, productId: productId } }
//         });
//         const sectionWrapper = wrapper.closest('.shopify-section');
//         if (sectionWrapper) sectionWrapper.dispatchEvent(variantUpdateEvent);
//         document.dispatchEvent(variantUpdateEvent);
//       })
//       .catch(function (err) { console.warn('QBM variant sync fetch error:', err); });
//   }

//   function getSectionId() {
//     const sectionWrapper = wrapper.closest('[id^="shopify-section-"]');
//     if (sectionWrapper) return sectionWrapper.id.replace('shopify-section-', '');
//     return '';
//   }

//   wrapper.addEventListener('change', function (e) {
//     const select = e.target.closest('[data-qbm-row-select]');
//     if (!select) return;
//     const row = select.closest('.qbm-variant-row');
//     const option = select.closest('[data-qbm-option]');
//     if (!row || !option) return;
//     updateOptionPrices();
//     if (option === selectedOption) {
//       const variant = findVariantForRow(row);
//       if (variant) syncMainProductWithVariant(variant);
//     }
//   });

//   function getOptionValueSets() {
//     const sets = {};
//     optionsMeta.forEach(function (meta) {
//       const key = 'option' + meta.position;
//       const valueSet = new Set();
//       allVariants.forEach(function (v) { if (v[key]) valueSet.add(v[key]); });
//       sets[meta.name] = valueSet;
//     });
//     return sets;
//   }

//   document.addEventListener('change', function (e) {
//     if (suppressMainListener) return;
//     if (!variantsLoaded) return;
//     const target = e.target;
//     if (!(target instanceof HTMLElement)) return;
//     if (target.closest('[data-qbm]')) return;

//     let value = null;
//     if (target.matches('input[type="radio"]')) {
//       if (!target.checked) return;
//       value = target.value;
//     } else if (target.matches('select')) {
//       if (target.name === 'id') return;
//       value = target.value;
//     } else {
//       return;
//     }
//     if (!value) return;

//     const valueSets = getOptionValueSets();
//     let matchedName = null;
//     Object.keys(valueSets).forEach(function (name) {
//       if (valueSets[name].has(value)) matchedName = name;
//     });
//     if (!matchedName) return;

//     wrapper.querySelectorAll('[data-qbm-row-select]').forEach(function (sel) {
//       if (sel.dataset.optionName !== matchedName) return;
//       const hasOption = Array.from(sel.options).some(function (o) { return o.value === value; });
//       if (hasOption) sel.value = value;
//     });

//     updateOptionPrices();
//   });

//   fetch('/products/' + encodeURIComponent(productHandle) + '.js')
//     .then(function (res) { return res.json(); })
//     .then(function (data) {
//       allVariants = data.variants || [];
//       optionsMeta = (data.options || []).map(function (name, idx) {
//         return { name: typeof name === 'string' ? name : name.name, position: idx + 1 };
//       });
//       variantsLoaded = true;
//       updateOptionPrices();
//     })
//     .catch(function (err) { console.error('QBM variant fetch error:', err); });

//   updateOptionPrices();

//   function buildCartItems() {
//     const rowVariantIds = (selectedOption && selectedOption.__rowVariantIds) || [];
//     if (rowVariantIds.length === 0) return null;
//     const items = rowVariantIds
//       .filter(function (id) { return id; })
//       .map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
//     return items.length > 0 ? items : null;
//   }

//   // ═══════════════════════════════════════════════════════════════════
//   // ADD TO CART
//   // ═══════════════════════════════════════════════════════════════════
//   if (addBtn) {
//     addBtn.addEventListener('click', function () {
//       if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
//       const items = buildCartItems();
//       if (!items) {
//         if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Please select a variant for each unit.'; }
//         return;
//       }
//       addBtn.disabled = true;
//       if (addSpinner) addSpinner.hidden = false;

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           return res.json().then(function (data) {
//             if (!res.ok) {
//               const msg = (data && (data.description || data.message)) || 'Could not add to cart';
//               throw new Error(msg);
//             }
//             return data;
//           });
//         })
//         .then(function () {
//           if (selectedCode) {
//             fetch('/discount/' + encodeURIComponent(selectedCode))
//               .finally(function () { window.location.href = '/cart'; });
//           } else {
//             window.location.href = '/cart';
//           }
//         })
//         .catch(function (err) {
//           if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || 'Something went wrong.'; }
//           resetAddToCartButton();
//         });
//     });
//   }

//   // ═══════════════════════════════════════════════════════════════════
//   // VIEW CART
//   // ═══════════════════════════════════════════════════════════════════
//   if (viewCartBtn) {
//     viewCartBtn.addEventListener('click', function () {
//       window.location.href = '/cart';
//     });
//   }

//   // ═══════════════════════════════════════════════════════════════════
//   // BUY NOW
//   // ═══════════════════════════════════════════════════════════════════
//   if (buyNowBtn) {
//     buyNowBtn.addEventListener('click', function () {
//       if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
//       const items = buildCartItems();
//       if (!items) {
//         if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Please select a variant for each unit.'; }
//         return;
//       }
//       buyNowBtn.disabled = true;
//       if (buyNowSpinner) buyNowSpinner.hidden = false;
//       if (buyNowText) buyNowText.textContent = 'Redirecting...';

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           return res.json().then(function (data) {
//             if (!res.ok) {
//               const msg = (data && (data.description || data.message)) || 'Could not add to cart';
//               throw new Error(msg);
//             }
//             return data;
//           });
//         })
//         .then(function () {
//           if (selectedCode) {
//             fetch('/discount/' + encodeURIComponent(selectedCode))
//               .finally(function () { window.location.href = '/checkout'; });
//           } else {
//             window.location.href = '/checkout';
//           }
//         })
//         .catch(function (err) {
//           if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || 'Something went wrong.'; }
//           resetBuyNowButton();
//         });
//     });
//   }
// });